import Vue from 'vue'
import VueRouter from 'vue-router'
import AboutUs from '../views/AboutUs.vue'
import ProductServe from '../views/ProductServe.vue'
import ServeShipper from '../views/serve/ServeShipper.vue'
import ServeDriver from '../views/serve/ServeDriver.vue'
import DownLoad from '../views/serve/DownLoad.vue'
import BusinessCooperation from '../views/BusinessCooperation.vue'
import StatusQuo from '../views/StatusQuo.vue'
import NewsList from "@/views/NewsList";
import NewsDetail from "@/views/NewsDetail";

Vue.use(VueRouter)

const routes = [
  //  关于我们
  {
    path: '/',
    name: 'aboutus',
    component: AboutUs,
    meta: {
      title: '关于我们',
    }
  },
  //  产品与服务
  {
    path: '/serve',
    name: 'serve',
    component: ProductServe
  },
  //  产品与服务 --> 货主发货
  {
    path: '/serve-serveshipper',
    name: 'serveshipper',
    component: ServeShipper
  },
  //  产品与服务 --> 司机接单
  {
    path: '/serve-servedriver',
    name: 'servedriver',
    component: ServeDriver
  },
  //  产品与服务 --> 产品下载
  {
    path: '/serve-download',
    name: 'download',
    component: DownLoad
  },
  //  业务合作
  {
    path: '/business',
    name: 'business',
    component: BusinessCooperation
  },
  // 现状和方案
  {
    path: '/statusquo',
    name: 'statusquo',
    component: StatusQuo
  },
    // 新闻列表
  {
    path: '/newslist',
    name: 'newslist',
    component: NewsList
  },
  //  新闻详情
  {
    path: '/newsdetail',
    name: 'newsdetail',
    component: NewsDetail
  },
]
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}
const router = new VueRouter({
  mode: 'history',
  base: 'ws',
  routes,
  //配置滚动行为，跳转到新的路由界面滚动条的位置
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})


export default router
